module.exports = __webpack_public_path__ + "assets/addpoint.5ac7427f.svg";